import Calendar from '@/components/calendar/Calendar';
import { ButtonSearch } from '@/components/common/Button';
import Combobox from '@/components/common/Combobox';
import { Form, FormControl, FormField, FormItem, FormMessage } from '@/components/common/Form';
import { Input } from '@/components/common/Input';
import { ORDER_STATUS_CMS, ORDER_STATUS_LIST } from '@/configs/constants';
import { useStore } from '@/hooks/useStore';
import { observer } from 'mobx-react-lite';
import { UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

interface FilterProps {
    form: UseFormReturn<any>,
    isInModal?: boolean,
    onSearch: (searchParams?: any) => void,
    isCancelBtn: boolean
}

export default observer(function FilterForm({ form, isInModal = false, onSearch, isCancelBtn }: FilterProps) {
    // hooks
    const { t } = useTranslation();

    // store
    const {
        accountStore: {
            accounts
        },
        locationStore: {
            locations
        }
    } = useStore();

    const OrderSatusList = ORDER_STATUS_LIST.map(status => ({
        label: t(ORDER_STATUS_CMS[status].key),
        value: status.toString(),
        code: status.toString()
    }));

    return (
        <Form {...form}>
            <form onSubmit={form.handleSubmit(onSearch)}>
                <div className='layout-filter max-h-[60vh] overflow-y-auto'>
                    <FormField
                        control={form.control}
                        name='orderStatus'
                        render={({ field }) => (
                            <FormItem className='w-full'>
                                <FormControl>
                                    <Combobox
                                        placeholder={t('field.reservation.reservation_status')}
                                        value={field.value?.toString() ?? ''}
                                        onChange={(item) => {
                                            field.onChange(item?.value ?? '');
                                        }}
                                        items={
                                            OrderSatusList
                                        }
                                        search={false}
                                    />
                                </FormControl>
                            </FormItem>
                        )}
                    />

                    <FormField
                        control={form.control}
                        name='locationId'
                        render={({ field }) => (
                            <FormItem className='w-full'>
                                <FormControl>
                                    <Combobox
                                        placeholder={t('field.location_name')}
                                        value={field.value?.toString() ?? ''}
                                        onChange={(item) => {
                                            field.onChange(item?.value ?? '');
                                        }}
                                        items={
                                            (Array.isArray(locations) && locations?.length ?
                                                [
                                                    ...locations.map(item => ({
                                                        label: item.name ?? '',
                                                        value: item.id.toString(),
                                                        code: item.id
                                                    }))
                                                ] :
                                                []
                                            )
                                        }
                                    />
                                </FormControl>
                            </FormItem>
                        )}
                    />
                    {!isInModal && (
                        <FormField
                            control={form.control}
                            name='customerName'
                            render={({ field }) => (
                                <FormItem className='w-full'>
                                    <FormControl>
                                        <Input
                                            type='text'
                                            placeholder={t('field.reservation.customer_name')}
                                            {...field}
                                        />
                                    </FormControl>
                                </FormItem>
                            )}
                        />
                    )}
                    {
                        isCancelBtn &&
                        (
                            <FormField
                                control={form.control}
                                name='ownerId'
                                render={({ field }) => (
                                    <FormItem className='w-full'>
                                        <FormControl>
                                            <Combobox
                                                placeholder={t('field.owner')}
                                                value={field.value?.toString() ?? ''}
                                                onChange={(item) => {
                                                    field.onChange(item?.value ?? '');
                                                }}
                                                items={
                                                    (Array.isArray(accounts) && accounts?.length ?
                                                        [
                                                            ...accounts.map(item => ({
                                                                label: item.fullname,
                                                                labelSearch: item.fullname + item?.userCode,
                                                                value: item.id.toString(),
                                                                code: item.id
                                                            }))
                                                        ] :
                                                        []
                                                    )
                                                }
                                            />
                                        </FormControl>
                                    </FormItem>
                                )}
                            />
                        )
                        // <Input className='w-full' disabled value={isEk ? profileEk?.email : profileGas?.email} />
                    }
                    <FormField
                        control={form.control}
                        name='rentalFrom'
                        render={({ field }) => (
                            <FormItem className='w-full'>
                                <FormControl>
                                    <Calendar
                                        mode='range'
                                        selected={field.value}
                                        onSelect={date => field.onChange(date ?? null)}
                                        useIconRemove={true}
                                        required={false}
                                        placeholder={t('field.reservation.rental_date')}
                                    />
                                </FormControl>
                                <FormMessage />
                            </FormItem>
                        )}
                    />
                    <FormField
                        control={form.control}
                        name='rentalTo'
                        render={({ field }) => (
                            <FormItem className='w-full'>
                                <FormControl>
                                    <Calendar
                                        mode='range'
                                        selected={field.value}
                                        onSelect={date => field.onChange(date ?? null)}
                                        useIconRemove={true}
                                        required={false}
                                        placeholder={t('field.reservation.return_date')}
                                    />
                                </FormControl>
                                <FormMessage />
                            </FormItem>
                        )}
                    />

                    <div className='col-span-full flex justify-center'>
                        <ButtonSearch size='md' className='max-w-52'>
                            {t('button.search')}
                        </ButtonSearch>
                    </div>
                </div>
            </form>
        </Form>
    );
});
